// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../../shared/components/accordion';
import ExternalNotes from '@deere/cps-it.warranty-model-factory/lib/external-notes';
import {FormattedMessage} from 'react-intl';
import InstructionsList from '../../../part-requests/request-details/components/instructions-panels/instructions-list';

const ExternalNotesPanel = props => {

    const title = (
        <span>
            <FormattedMessage id='MACHINE_INFORMATION'/>
        </span>
    );

    const body = (
        <div className='external-notes'>
            <InstructionsList instructions={props.externalNotes.notes}/>
        </div>
    );

    return (
        <Accordion
            accordionId='external-notes-accordion'
            body={body}
            isExpanded={props.isExpanded}
            onClick={props.onClick}
            title={title}
        />
    );

};

ExternalNotesPanel.displayName = 'ExternalNotesPanel';
ExternalNotesPanel.propTypes = {
    externalNotes: PropTypes.instanceOf(ExternalNotes).isRequired,
    isExpanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
};

export default ExternalNotesPanel;



// WEBPACK FOOTER //
// ./src/product/details/components/external-notes-panel.js